import { readFile } from "fs/promises";
import "path";
function makeMatrix(data, home_lineup, away_lineup) {
  var playerRoles = {};
  const playerIds = /* @__PURE__ */ new Set();
  for (const eventId in data) {
    const event = data[eventId];
    if (home_lineup[event.from] == void 0)
      playerRoles[event.from] = (home_lineup[event.from] ?? {}).role || (away_lineup[event.from] ?? {}).role;
    playerRoles[event.to] = (home_lineup[event.to] ?? {}).role || (away_lineup[event.to] ?? {}).role;
    playerIds.add(event.from);
    playerIds.add(event.to);
  }
  const playerArray = Array.from(playerIds);
  const matrix = Array.from(
    { length: playerIds.size },
    () => Array(playerIds.size).fill(0)
  );
  for (const eventId in data) {
    const event = data[eventId];
    const fromIndex = playerArray.indexOf(event.from);
    const toIndex = playerArray.indexOf(event.to);
    matrix[fromIndex][toIndex]++;
  }
  return [matrix, Array.from(playerIds), playerRoles];
}
function calculateTotals(matrix) {
  const rowCount = matrix?.length ?? 0;
  const colCount = matrix[0]?.length ?? 0;
  const rowTotals = new Array(rowCount).fill(0);
  const colTotals = new Array(colCount).fill(0);
  for (let i = 0; i < rowCount; i++) {
    for (let j = 0; j < colCount; j++) {
      rowTotals[i] += matrix[i][j];
      colTotals[j] += matrix[i][j];
    }
  }
  return { rowTotals, colTotals };
}
const orderRole = {
  undefined: 99,
  goalkeeper: 0,
  defender: 1,
  midfielder: 2,
  forward: 3
};
function sortMatrix(matrix, rowTotals, colTotals, colNames, rowNames, playerRoles) {
  const rowCount = matrix?.length ?? 0;
  const colCount = matrix[0]?.length ?? 0;
  const colIndices = Array.from({ length: colCount }, (_, i) => i);
  colIndices.sort(
    (a, b) => playerRoles[colNames[b]] == playerRoles[colNames[a]] ? colTotals[b] - colTotals[a] : orderRole[playerRoles[colNames[a]]] - orderRole[playerRoles[colNames[b]]]
  );
  const sortedMatrix = [];
  for (let i = 0; i < rowCount; i++) {
    const newRow = colIndices.map((colIndex) => matrix[i][colIndex]);
    sortedMatrix.push(newRow);
  }
  const rowIndices = colIndices;
  const finalMatrix = [];
  for (let i = 0; i < rowCount; i++) {
    finalMatrix.push(sortedMatrix[rowIndices[i]]);
  }
  return {
    newmatrix: finalMatrix,
    newcolNames: colNames.map((v, i, l) => colNames[colIndices[i]]),
    newrowNames: rowNames.map((v, i, l) => rowNames[rowIndices[i]])
  };
}
const passMatrixBuild = (data, team) => {
  const dt = makeMatrix(
    Object.values(data.events ?? {}).filter(
      (v, i, l) => (v.type = "pass") && v.fromTeam == v.toTeam && v.toTeam == team
      // "home"
    ),
    (team == "home" ? data.home_lineup : data.away_lineup) ?? {},
    (team == "home" ? data.away_lineup : data.home_lineup) ?? {}
  );
  const matrix = dt[0];
  const colNames = Array.from(dt[1]);
  const rowNames = Array.from(dt[1]);
  const playerRoles = dt[2];
  const { rowTotals, colTotals } = calculateTotals(matrix);
  let { newmatrix, newcolNames, newrowNames } = sortMatrix(
    matrix,
    rowTotals,
    colTotals,
    colNames,
    rowNames,
    playerRoles
  );
  colNames.sort(
    (a, b) => colTotals[colNames.indexOf(b)] - colTotals[colNames.indexOf(a)]
  );
  rowNames.sort(
    (a, b) => rowTotals[rowNames.indexOf(b)] - rowTotals[rowNames.indexOf(a)]
  );
  return {
    passes: newmatrix,
    // lineup: colNames,
    lineup: newcolNames,
    // rowNames: rowNames,
    rowNames: newrowNames,
    colNames: newcolNames,
    playerRoles
  };
};
const prerender = false;
const filePath = "src/_games.json";
const eventsFor = (event, playerid, events) => Object.values(events ?? {})?.filter(
  (v, i, l) => v.type == event && (v.to == playerid || v.from == playerid || v.fromTeam == playerid)
  // ||
  // v.toTeam == playerid
);
async function load({ fetch, params }) {
  const homeoraway = params.homeoraway == "home";
  const data = JSON.parse(await readFile(filePath, "utf8"))[params.id];
  const homepasses = passMatrixBuild(data, "home");
  const awaypasses = passMatrixBuild(data, "away");
  const homelineup_ = JSON.parse(await readFile(filePath, "utf8"))[
    // (await read("/" + path.resolve("./") + "/" + filePath).json())
    params.id
  ]?.home_lineup ?? // (await read(filePath).json())[params.id]?.home_lineup ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}/home_lineup.json`
  )).json();
  const awaylineup_ = JSON.parse(await readFile(filePath, "utf8"))[
    // (await read("/" + path.resolve("./") + "/" + filePath).json())
    params.id
  ]?.away_lineup ?? // (await read(filePath).json())[params.id]?.away_lineup ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}/away_lineup.json`
  )).json() ?? {};
  const homelineup = homeoraway ? homelineup_ : awaylineup_;
  const awaylineup = homeoraway ? awaylineup_ : homelineup_;
  const events = JSON.parse(await readFile(filePath, "utf8"))[
    // (await read("/" + path.resolve("./") + "/" + filePath).json())
    params.id
  ]?.events ?? // (await read(filePath).json())[params.id]?.events ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}/events.json`
  )).json();
  const homeplayerstats = Object.keys(
    homelineup ?? {}
  ).map((playerid, i, l) => {
    return {
      // profile
      ...homelineup[playerid],
      id: playerid,
      name: homelineup[playerid]?.name,
      passes: (
        // ?.filter(
        //   (v, i, l) => v.from == playerid
        // )
        eventsFor("pass", playerid, events)?.length
      ),
      lostballs: eventsFor("lost-ball", playerid, events)?.filter(
        (v, i2, l2) => v.from == playerid && awaylineup[v.to]?.role != "goalkeeper"
      )?.length + eventsFor("pass", playerid, events)?.filter(
        (v, i2, l2) => v.from == playerid && awaylineup[v.to] != void 0 && awaylineup[v.to]?.role != "goalkeeper"
      )?.length,
      tackles: eventsFor("lost-ball", playerid, events)?.filter(
        (v, i2, l2) => v.to == playerid
      )?.length + eventsFor("pass", playerid, events)?.filter(
        (v, i2, l2) => v.to == playerid && awaylineup[v.from] != void 0
      )?.length
    };
  });
  return {
    id: params.id,
    homeplayerstats: homeplayerstats.filter((v, i, l) => v.passes > 0),
    // passes: dt[0],
    // lineup: Array.from(dt[1]),
    // passes: matrix,
    passes: homeoraway ? homepasses.passes : awaypasses.passes,
    // lineup: colNames,
    lineup: homeoraway ? homepasses.lineup : awaypasses.lineup,
    // rowNames: rowNames,
    rowNames: homeoraway ? homepasses.rowNames : awaypasses.rowNames,
    colNames: homeoraway ? homepasses.colNames : awaypasses.colNames,
    playerRoles: homeoraway ? homepasses.playerRoles : awaypasses.playerRoles,
    //dt[2],
    // passes: homepasses.passes,
    // // lineup: colNames,
    // lineup: homepasses.lineup,
    // // rowNames: rowNames,
    // rowNames: homepasses.rowNames,
    // colNames: homepasses.colNames,
    // playerRoles: homepasses.playerRoles, //dt[2],
    homepasses: homeoraway ? homepasses : awaypasses,
    awaypasses: homeoraway ? awaypasses : homeoraway
  };
}
export {
  load,
  prerender
};
